export default {
  getShowCreateEditView: state => state.showCreateEditView ?? false,
  getShowCreateEditBackArrow: state => state.showCreateEditBackArrow ?? false,
}
